function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useReducer, useState } from 'react';
import { ariaDescribedByIds, dateRangeOptions, parseDateString, toDateString, TranslatableString, getDateElementProps } from '@rjsf/utils';

function readyForChange(state) {
  return Object.values(state).every(function (value) {
    return value !== -1;
  });
}

function DateElement(_ref) {
  var type = _ref.type,
      range = _ref.range,
      value = _ref.value,
      select = _ref.select,
      rootId = _ref.rootId,
      name = _ref.name,
      disabled = _ref.disabled,
      readonly = _ref.readonly,
      autofocus = _ref.autofocus,
      registry = _ref.registry,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus;
  var id = rootId + '_' + type;
  var SelectWidget = registry.widgets.SelectWidget;
  return _jsx(SelectWidget, {
    schema: {
      type: 'integer'
    },
    id: id,
    name: name,
    className: 'form-control',
    options: {
      enumOptions: dateRangeOptions(range[0], range[1])
    },
    placeholder: type,
    value: value,
    disabled: disabled,
    readonly: readonly,
    autofocus: autofocus,
    onChange: function onChange(value) {
      return select(type, value);
    },
    onBlur: onBlur,
    onFocus: onFocus,
    registry: registry,
    label: '',
    "aria-describedby": ariaDescribedByIds(rootId)
  });
}
/** The `AltDateWidget` is an alternative widget for rendering date properties.
 * @param props - The `WidgetProps` for this component
 */


function AltDateWidget(_ref2) {
  var _ref2$time = _ref2.time,
      time = _ref2$time === void 0 ? false : _ref2$time,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$readonly = _ref2.readonly,
      readonly = _ref2$readonly === void 0 ? false : _ref2$readonly,
      _ref2$autofocus = _ref2.autofocus,
      autofocus = _ref2$autofocus === void 0 ? false : _ref2$autofocus,
      options = _ref2.options,
      id = _ref2.id,
      name = _ref2.name,
      registry = _ref2.registry,
      onBlur = _ref2.onBlur,
      onFocus = _ref2.onFocus,
      onChange = _ref2.onChange,
      value = _ref2.value;
  var translateString = registry.translateString;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      lastValue = _useState2[0],
      setLastValue = _useState2[1];

  var _useReducer = useReducer(function (state, action) {
    return _objectSpread(_objectSpread({}, state), action);
  }, parseDateString(value, time)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      setState = _useReducer2[1];

  useEffect(function () {
    var stateValue = toDateString(state, time);

    if (readyForChange(state) && stateValue !== value) {
      // The user changed the date to a new valid data via the comboboxes, so call onChange
      onChange(stateValue);
    } else if (lastValue !== value) {
      // We got a new value in the props
      setLastValue(value);
      setState(parseDateString(value, time));
    }
  }, [time, value, onChange, state, lastValue]);
  var handleChange = useCallback(function (property, value) {
    setState(_defineProperty({}, property, value));
  }, []);
  var handleSetNow = useCallback(function (event) {
    event.preventDefault();

    if (disabled || readonly) {
      return;
    }

    var nextState = parseDateString(new Date().toJSON(), time);
    onChange(toDateString(nextState, time));
  }, [disabled, readonly, time]);
  var handleClear = useCallback(function (event) {
    event.preventDefault();

    if (disabled || readonly) {
      return;
    }

    onChange(undefined);
  }, [disabled, readonly, onChange]);
  return _jsxs("ul", {
    className: 'list-inline',
    children: [getDateElementProps(state, time, options.yearsRange, options.format).map(function (elemProps, i) {
      return _jsx("li", {
        className: 'list-inline-item',
        children: _jsx(DateElement, _objectSpread(_objectSpread({
          rootId: id,
          name: name,
          select: handleChange
        }, elemProps), {}, {
          disabled: disabled,
          readonly: readonly,
          registry: registry,
          onBlur: onBlur,
          onFocus: onFocus,
          autofocus: autofocus && i === 0
        }))
      }, i);
    }), (options.hideNowButton !== 'undefined' ? !options.hideNowButton : true) && _jsx("li", {
      className: 'list-inline-item',
      children: _jsx("a", {
        href: '#',
        className: 'btn btn-info btn-now',
        onClick: handleSetNow,
        children: translateString(TranslatableString.NowLabel)
      })
    }), (options.hideClearButton !== 'undefined' ? !options.hideClearButton : true) && _jsx("li", {
      className: 'list-inline-item',
      children: _jsx("a", {
        href: '#',
        className: 'btn btn-warning btn-clear',
        onClick: handleClear,
        children: translateString(TranslatableString.ClearLabel)
      })
    })]
  });
}

export default AltDateWidget;